import { render } from "./RouteLoading.vue?vue&type=template&id=f94a4074&scoped=true"
import script from "./RouteLoading.vue?vue&type=script&lang=js"
export * from "./RouteLoading.vue?vue&type=script&lang=js"

import "./RouteLoading.vue?vue&type=style&index=0&id=f94a4074&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94a4074"]])

export default __exports__